module.exports = __webpack_public_path__ + "img/syariah_mandiri.27ee7980.svg";